import { Flex, Link, Text } from "@/atoms"
import {
  getApplicationSourceDisplay,
  getResourceDrawer
} from "@/helpers/application-source.helper"
import { Image } from "@/icons"
import { IMAGE_DRAWER_ID } from "@/organisms/Drawers/const"

import type { MetaImageComponent } from "."

const MetaImage: MetaImageComponent = ({
  record,
  onRowClick,
  classes = {},
  ...props
}) => {
  const { Icon = Image } = getApplicationSourceDisplay(record) || {}
  const { drawerId, key } = getResourceDrawer(record, IMAGE_DRAWER_ID)

  return (
    <Flex gap={8} align="center">
      <Icon className={classes?.icon} />
      <Link
        type="link"
        className={classes?.link}
        onClick={() => onRowClick({ key }, drawerId)}
      >
        <Text className={classes?.text} copyable {...props}>
          {record.name}
        </Text>
      </Link>
    </Flex>
  )
}

export default MetaImage
